export default __webpack_public_path__ + "static/media/slider6.ee73de13.jpg";